// import React, { useState, useEffect } from "react";
// import ReactECharts from "echarts-for-react";
// import * as echarts from "echarts";
// import { palette, theme as colorTheme } from "../../../../Convoze.theme";

// const AgentAnalytics = ({ cardDetails }) => {
//   const hangupByCounts = cardDetails?.callHangup?.hangupByCounts || [];
//   const agentNames = cardDetails?.callHangup?.agentNames || [];
//   const totalCalls = cardDetails?.callHangup?.totalCalls || [];

//   const option = {
//     title: {
//       text: "Agent Analytics ",
//     },
//     tooltip: {
//       trigger: "axis",
//       axisPointer: {
//         type: "shadow",
//         label: {
//           backgroundColor: "#283b56",
//         },
//       },
//     },
//     legend: {
//       data: ["Total Calls", "Call Hang Up By Agent"],
//       left: "right",
//     },
//     xAxis: {
//       type: "category",
//       data: agentNames,
//       axisLabel: {
//         rotate: 30,
//         fontSize: 10,
//       },
//     },
//     yAxis: {
//       type: "value",
//       min: 0,
//     },

//     series: [
//       {
//         name: "Total Calls",
//         type: "bar",
//         data: totalCalls,
//         itemStyle: {
//           color :  colorTheme('palette', 'primary').value,
//         },
//         label: {
//           show: true,
//           position: "top",
//         },
//         barWidth: 30,
//       },
//       {
//         name: "Call Hang Up By Agent",
//         type: "line",
//         data: hangupByCounts,
//         itemStyle: {
//           color :  colorTheme('palette', 'primary').value,
//         },

//         label: {
//           show: true,
//           position: "bottom",
//           color: "#fff",
//         },
//         barWidth: 30,
//       },
//     ],
//   };

//   return (
//     <ReactECharts
//       option={option}
//       style={{ height: "50vh", width: "100%" }}
//       echarts={echarts}
//     />
//   );
// };

// export default AgentAnalytics

import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
import { Box, Typography } from "@mui/material";

const AgentAnalytics = ({ cardDetails }) => {
  const hangupByCounts = cardDetails?.callHangup?.hangupByCounts || [];
  const agentNames = cardDetails?.callHangup?.agentNames || [];
  const totalCalls = cardDetails?.callHangup?.totalCalls || [];

  const hasData = agentNames.length > 0;

  const option = {
    title: {
      text: "Agent Analytics",
      textStyle: {
        fontSize: 14,
        fontWeight: 700,
        color: "#464646",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow", label: { backgroundColor: "#283b56" } },
    },
    legend: { data: ["Total Calls", "Call Hang Up By Agent"], left: "right" },
    xAxis: {
      type: "category",
      data: agentNames,
      axisLabel: { rotate: 30, fontSize: 10 },
    },
    yAxis: { type: "value", min: 0 },
    series: [
      {
        name: "Total Calls",
        type: "bar",
        data: totalCalls,
        itemStyle: { color: colorTheme("palette", "primary").value },
        label: { show: true, position: "top" },
        barWidth: 30,
      },
      {
        name: "Call Hang Up By Agent",
        type: "line",
        data: hangupByCounts,
        itemStyle: { color: "orange" },
        lineStyle: { color: "orange", width: 2 },
        symbol: "circle",
        symbolSize: 6,
        label: { show: true, position: "bottom", color: "orange" },
        barWidth: 30,
      },
    ],
  };

  return (
    <Box
      sx={{
        height: "50vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!hasData && (
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          mb="20px"
        >
          <Typography
            fontSize={14}
            variant="body2"
            color="#464646"
            fontWeight={700}
          >
            Agent Analytics
          </Typography>
        </Box>
      )}

      {/* content */}
      {hasData ? (
        <ReactECharts option={option} style={{ flex: 1 }} echarts={echarts} />
      ) : (
        <Box
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="1rem"
          fontWeight={600}
          color="#999"
          borderRadius="8px"
        >
          No data available
        </Box>
      )}
    </Box>
  );
};

export default AgentAnalytics;